




import { Vue, Component } from "vue-property-decorator";
import IncomingTariff from "@/pages/Pages/Tarification/IncomingTariff.vue";
import { MsgTransports } from "@/store/types";

@Component({
  components: { IncomingTariff },
})
export default class ViberIncomingTariff extends Vue {
  private transport: MsgTransports = MsgTransports.WHATSAPP;
}
